import { createGenericContext, GetBemBlocksWith } from "@ebsco-ui/utils";

export interface TabsContext {
  isDisabled: boolean;
  getBemBlocksWith: GetBemBlocksWith;
}

export const {
  useGenericContext: useTabsContext,
  GenericContextConsumer: TabsContextConsumer,
  GenericContextProvider: TabsContextProvider,
} = createGenericContext<TabsContext>({
  errorMessage:
    "Tabs compound components cannot be rendered outside of the Tabs component",
});
